module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-team"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "c-team__list"
  }, _vm._l((_vm.team), function(member) {
    return _c('li', {
      staticClass: "c-team__list-item"
    }, [_c('div', {
      staticClass: "c-team__member-image"
    }, [_c('img', {
      attrs: {
        "src": member.image.sizes.large,
        "alt": member.name
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "c-team__member-title"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(member.name) + "\n\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "c-team__member-desc"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(member.description) + "\n\t\t\t\t")]), _vm._v(" "), (member.email) ? _c('a', {
      staticClass: "c-team__member-email",
      attrs: {
        "href": 'mailto:' + member.email
      }
    }, [_vm._v(_vm._s(member.email))]) : _vm._e()])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c058cfc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 279
// module chunks = 0